// Mock data for Ruminating Room website

export const portfolioItems = [
  {
    id: 1,
    title: "Couture Bridal Showcase",
    category: "Bridal & Couture",
    beforeImage: "https://images.unsplash.com/photo-1772909566980-b06731149511?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxoaWdoJTIwZmFzaGlvbiUyMGx1eHVyeXxlbnwwfHx8fDE3NzM5MDk0NjZ8MA&ixlib=rb-4.1.0&q=85",
    afterImage: "https://images.unsplash.com/photo-1764998113473-bae96c1c3072?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxoaWdoJTIwZmFzaGlvbiUyMGx1eHVyeXxlbnwwfHx8fDE3NzM5MDk0NjZ8MA&ixlib=rb-4.1.0&q=85",
    description: "From sketch and flatlay to premium bridal model rendering."
  },
  {
    id: 2,
    title: "Couture Collection Visuals",
    category: "Couture & Editorial",
    beforeImage: "https://images.unsplash.com/photo-1561060511-78b14b799fe1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxoaWdoJTIwZmFzaGlvbiUyMGx1eHVyeXxlbnwwfHx8fDE3NzM5MDk0NjZ8MA&ixlib=rb-4.1.0&q=85",
    afterImage: "https://images.unsplash.com/photo-1709887139259-e5fdce21afa8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxmYXNoaW9uJTIwZWRpdG9yaWFsJTIwbW9kZWx8ZW58MHx8fHwxNzczOTA5NDcwfDA&ixlib=rb-4.1.0&q=85",
    description: "Virtual couture styling built for luxe e-commerce and lookbooks."
  },
  {
    id: 3,
    title: "Campaign Storytelling",
    category: "High-End Visuals",
    beforeImage: "https://images.unsplash.com/photo-1768885560973-454bc193824d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxoaWdoJTIwZmFzaGlvbiUyMGx1eHVyeXxlbnwwfHx8fDE3NzM5MDk0NjZ8MA&ixlib=rb-4.1.0&q=85",
    afterImage: "https://images.unsplash.com/photo-1687884578968-94d89d7e30cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxmYXNoaW9uJTIwZWRpdG9yaWFsJTIwbW9kZWx8ZW58MHx8fHwxNzczOTA5NDcwfDA&ixlib=rb-4.1.0&q=85",
    description: "Cinematic campaign visuals for couture brands without a single shoot day."
  }
];

export const services = [
  {
    id: 1,
    title: "Virtual Bridal & Couture Try-on",
    description: "Preview gowns, lehengas and couture in hyper-real styling before launch."
  },
  {
    id: 2,
    title: "98% Garment Accuracy",
    description: "Precision fabric drape, texture and fit for true-to-life visuals."
  },
  {
    id: 3,
    title: "Campaign & Creative Direction",
    description: "High-end visuals, lookbooks and digital campaigns built for premium brands."
  }
];

export const differentiators = [
  {
    id: 1,
    title: "98% Garment Accuracy",
    description: "Industry-leading precision in fabric, silhouette, and detail."
  },
  {
    id: 2,
    title: "Shoot-Free Production",
    description: "Skip models, locations, and logistics while retaining premium quality."
  },
  {
    id: 3,
    title: "Bridal & Couture Expertise",
    description: "Specialized visuals for luxury bridal wear, couture, and editorial storytelling."
  },
  {
    id: 4,
    title: "Speed & Consistency",
    description: "Fast delivery with reliable visual quality across every piece."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "How AI is changing fashion shoots",
    excerpt: "The transformation from traditional photography to AI-powered production.",
    date: "Dec 2025",
    slug: "ai-fashion-shoots"
  },
  {
    id: 2,
    title: "Virtual try-on vs traditional shoots",
    excerpt: "A cost and quality comparison for fashion brands.",
    date: "Dec 2025",
    slug: "virtual-vs-traditional"
  },
  {
    id: 3,
    title: "Future of fashion visuals",
    excerpt: "What's next in AI-powered fashion production.",
    date: "Nov 2025",
    slug: "future-fashion-visuals"
  }
];

export const animationProjects = [
  {
    id: 1,
    title: "I Don't Know",
    type: "Microdrama Series",
    description: "An exploration of uncertainty in modern relationships through visual storytelling.",
    image: "https://images.unsplash.com/photo-1760113671986-63ccb46ae202",
    themes: ["Relationships", "Identity"]
  },
  {
    id: 2,
    title: "Platform Stories",
    type: "Short Film",
    description: "Moments of modern Indian life captured between destinations.",
    image: "https://images.unsplash.com/photo-1759863738666-7584248cdf7e",
    themes: ["Modern Life", "Solitude"]
  },
  {
    id: 3,
    title: "Urban Satire",
    type: "Animation Series",
    description: "Dark comedy exploring the absurdity of metropolitan existence.",
    image: "https://images.unsplash.com/photo-1658806264102-2c516eae5e05",
    themes: ["Satire", "Urban Life"]
  }
];

export const themes = [
  {
    id: 1,
    title: "Modern Indian Life",
    description: "Contemporary narratives rooted in cultural context."
  },
  {
    id: 2,
    title: "Relationships & Identity",
    description: "Intimate explorations of human connection and self-discovery."
  },
  {
    id: 3,
    title: "Satire & Dark Comedy",
    description: "Sharp observations wrapped in wit and irony."
  }
];
